"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Attempts to convert a given value to a Number and returns zero if that attempt produced `NaN`.
 *
 * @example
 * import alwaysNumber from '@carvana/futilities/alwaysNumber';
 * alwaysNumber('300.17')
 * // () => 300.17
 * alwaysNumber('abc')
 * // () => 0
 * alwaysNumber()
 * // () => 0
 */
function alwaysNumber(value) {
    return Number.isNaN(+value) ? 0 : +value;
}
exports.default = alwaysNumber;
//# sourceMappingURL=alwaysNumber.js.map